import type { Option, AssigneeOption } from '../options';

export type { Option, AssigneeOption };

// Status filter options for tickets (reminders)
export const statusFilterOptions: Option[] = [
  // { title: 'All', value: '' }, // Hidden, used only for local testing
  { title: 'Pending', value: 'pending' },
  { title: 'Due Today', value: 'dueToday' },
  { title: 'Overdue', value: 'overdue' },
  { title: 'Open', value: 'open' },
  { title: 'Completed', value: 'completed' },
  { title: 'Dismissed', value: 'canceled' }, // Hidden, used only for local testing
];

export type StatusFilterValue = 'pending' | 'dueToday' | 'overdue' | 'open' | 'completed' | 'canceled';

export const DEFAULT_ASSIGNEE = { title: 'All', value: '' };
export const defaultAssigneeOptions: AssigneeOption[] = [DEFAULT_ASSIGNEE];
